import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OnlineContext = createContext({ onlineUsers: new Set(), isOnline: () => false });

export const OnlineProvider = ({ children }) => {
  const [onlineUsers, setOnlineUsers] = useState(new Set());

  const fetchOnlineStatus = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/social/online-status`, { withCredentials: true });
      setOnlineUsers(new Set(data.online_users || []));
    } catch {}
  }, []);

  useEffect(() => {
    fetchOnlineStatus();
    const interval = setInterval(fetchOnlineStatus, 30000);
    return () => clearInterval(interval);
  }, [fetchOnlineStatus]);

  const isOnline = useCallback((userId) => onlineUsers.has(userId), [onlineUsers]);

  return (
    <OnlineContext.Provider value={{ onlineUsers, isOnline }}>
      {children}
    </OnlineContext.Provider>
  );
};

export const useOnlineStatus = () => useContext(OnlineContext);

export const OnlineDot = ({ userId, className = '' }) => {
  const { isOnline } = useOnlineStatus();
  if (!isOnline(userId)) return null;
  return (
    <span
      className={`absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full ${className}`}
      data-testid={`online-dot-${userId}`}
      title="En ligne"
    />
  );
};

export default OnlineProvider;
